import React, { useEffect } from 'react';
import { IonApp } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { setupIonicReact } from '@ionic/react';
import HeaderTabs from './components/HeaderTabs/HeaderTabs';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

/* Global application styles */
import './theme/theme.scss';
import ServerDBContext from './components/ServerDBContext/ServerDBContext';
import FellowshipService from './services/FellowshipService';
import FellowshipConnect from './components/FellowshipConnect/FellowshipConnect';
import NoSleepContext from './components/NoSleepContext/NoSleepContext';
import NoSleep from 'nosleep.js';
import AnalyticsService from './services/AnalyticsService';
import { isPlatform } from '@ionic/core';
import { Insomnia } from '@awesome-cordova-plugins/insomnia';
import { StatusBar, Style } from '@capacitor/status-bar';
import NetworkStatusContext from './components/NetworkStatusContext/NetworkStatusContext';
import NetworkService from './services/NetworkService';
import Parser from 'ua-parser-js';

const App: React.FC = () => {
  setupIonicReact({
    platform: {
      /** The default `desktop` function returns false for devices with a touchscreen.
      * This is not always wanted, so this function tests the User Agent instead.
      **/
      desktop: (win) => {
        const userAgent = Parser(win.navigator.userAgent);
        console.log('DEVICE TYPE: ', userAgent.device.type);
        return userAgent.device.type !== 'mobile';
      },
      mobile: (win) => {
        //const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(win.navigator.userAgent);
        const userAgent = Parser(win.navigator.userAgent);
        console.log('DEVICE TYPE: ', userAgent.device.type);
        return userAgent.device.type === 'mobile';
      },
    },
  });

  useEffect(() => {
    AnalyticsService.initAnalyticsLog();
    
    if(isPlatform('hybrid')) {
      StatusBar.setStyle({ style: Style.Light });
      StatusBar.setBackgroundColor({
        color: '#FFFFFF'
      });
      StatusBar.setOverlaysWebView({
        overlay: false
      })
      StatusBar.show();
    }
  }, []);

  const createNoSleep = ()  => {
    if(isPlatform('hybrid')) {
      return Insomnia;
    } else if (!isPlatform('ios')) {
      return new NoSleep();
    } else {
      return null;
    }
  }
  
  return (
    <IonApp>
      <IonReactRouter>
        <NetworkStatusContext.Provider value={ new NetworkService() }>
          <ServerDBContext.Provider value={ new FellowshipService() }>
          <FellowshipConnect></FellowshipConnect>
          <NoSleepContext.Provider value={ createNoSleep() }>
            <HeaderTabs></HeaderTabs>
          </NoSleepContext.Provider>
          </ServerDBContext.Provider>
        </NetworkStatusContext.Provider>
      </IonReactRouter>
    </IonApp>
  );
}
export default App;
